import React from 'react';
import PropTypes from 'prop-types';
import './PanoramicModal.scss';
import { setClassNames } from 'ddc-classnames-js';

import { Modal } from 'react-bootstrap';
import PanoramicImage from './PanoramicImage';

const PanoramicModal = ({ closeModal, isOpen, isMobile, lastImage }) => {
	const modalClassName = setClassNames([
		'panoramic-modal',
		'responsive',
		isMobile && 'mobile-modal'
	]);

	const modalCloseBtnClasses = setClassNames([
		'ddc-icon',
		'ddc-icon-remove2',
		isMobile ? '' : 'ddc-icon-size-large'
	]);

	return (
		<div>
			<Modal
				show={isOpen}
				onHide={closeModal}
				className={modalClassName}
				dialogClassName="my-0 mx-auto center-block-vertical"
				backdrop="static"
			>
				<Modal.Header>
					<button
						type="button"
						aria-label="Close"
						className="close mt-2"
						onClick={closeModal}
					>
						<i
							className={modalCloseBtnClasses}
							aria-hidden="true"
						/>
					</button>
				</Modal.Header>
				<Modal.Body>
					<PanoramicImage panoramicImg={lastImage} />
				</Modal.Body>
			</Modal>
		</div>
	);
};

PanoramicModal.propTypes = {
	closeModal: PropTypes.func.isRequired,
	isOpen: PropTypes.bool.isRequired,
	isMobile: PropTypes.bool,
	lastImage: PropTypes.shape({
		src: PropTypes.string,
		thumbnail: PropTypes.string
	})
};

export default PanoramicModal;
